module.exports = __webpack_public_path__ + "static/img/sy01.c7b70c3f.png";